import { useState, useEffect } from "react";
import parse from "html-react-parser";
import { StarsSections } from "../http/server-apis.js";
import Navigation from "../components/Navigation.jsx";
import BottomAppBar from "../components/BottomBar.jsx";
import Skeleton from "@mui/material/Skeleton";
import { useSelector } from "react-redux";

const About = () => {
  const { selectedLanguage } = useSelector((state) => state.Language);
  const [aboutData, setAboutData] = useState([]);
  const aboutLoader = [1, 2, 3];
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    async function fetchAboutAPI() {
      try {
        setIsLoading(true);
        const response = await StarsSections("post", {
          data: {
            SectionSlug: "our-mission",
            LangCode: selectedLanguage,
          },
        });
        if (response.status === 200) {
          setAboutData(response.data.SectionsDetails);
          setIsLoading(false);
        }
      } catch (error) {
        setAboutData([]);
        setIsLoading(false);
      }
    }
    fetchAboutAPI();
  }, [selectedLanguage]);

  return (
    <>
      <Navigation title={"ABOUT"} appBarColor="orange" />
      <div className="fixed-layout-main flex">
        <div className="white-card my-2 ">
          <div className="h-[70vh] sm:h-[75vh] overflow-y-scroll">
            {isLoading ? (
              <>
                {aboutLoader.map((index) => (
                  <div key={index}>
                    <Skeleton
                      sx={{ margin: "0 auto" }}
                      animation="wave"
                      variant="rounded"
                      width={240}
                      height={180}
                    />
                    <Skeleton
                      sx={{ margin: "10px 0px", width: "100%" }}
                      animation="wave"
                      variant="rounded"
                      height={10}
                    />

                    <Skeleton
                      sx={{ margin: "3px 0px", width: "100%" }}
                      animation="wave"
                      variant="rounded"
                      height={8}
                    />
                    <Skeleton
                      sx={{ margin: "3px 0px", width: "100%" }}
                      animation="wave"
                      variant="rounded"
                      height={8}
                    />
                    <Skeleton
                      sx={{ margin: "3px 0px", width: "100%" }}
                      animation="wave"
                      variant="rounded"
                      height={8}
                    />
                    <Skeleton
                      sx={{ margin: "3px 0px", width: "100%" }}
                      animation="wave"
                      variant="rounded"
                      height={8}
                    />
                    <Skeleton
                      sx={{ margin: "3px 0px", width: "100%" }}
                      animation="wave"
                      variant="rounded"
                      height={8}
                    />
                    <Skeleton
                      sx={{ margin: "3px 0px", width: "100%" }}
                      animation="wave"
                      variant="rounded"
                      height={8}
                    />
                    <Skeleton
                      sx={{ margin: "3px 0px", width: "100%" }}
                      animation="wave"
                      variant="rounded"
                      height={8}
                    />
                    <Skeleton
                      sx={{ margin: "3px 0px", width: "100%" }}
                      animation="wave"
                      variant="rounded"
                      height={8}
                    />
                    <Skeleton
                      sx={{ margin: "3px 0px", width: "100%" }}
                      animation="wave"
                      variant="rounded"
                      height={8}
                    />

                    <Skeleton
                      sx={{ margin: "10px 0px", width: "100%" }}
                      animation="wave"
                      variant="rounded"
                      height={10}
                    />
                    <Skeleton
                      sx={{ margin: "3px 0px", width: "100%" }}
                      animation="wave"
                      variant="rounded"
                      height={8}
                    />
                    <Skeleton
                      sx={{ margin: "3px 0px", width: "100%" }}
                      animation="wave"
                      variant="rounded"
                      height={8}
                    />
                    <Skeleton
                      sx={{ margin: "3px 0px", width: "100%" }}
                      animation="wave"
                      variant="rounded"
                      height={8}
                    />
                    <br />
                    <br />
                  </div>
                ))}
              </>
            ) : (
              aboutData?.map((singleAbout) => {
                return (
                  <div key={singleAbout.Image} className="pb-8">
                    <img
                      className="text-center mx-auto"
                      alt="aboutimg"
                      src={singleAbout.Image}
                    />
                    <p className=" text-sm mt-3 text-secondary font-semibold my-2 md:text-base lg:text-base">
                      {" "}
                      {singleAbout.Title}{" "}
                    </p>
                    <p className=" text-sm text-justify font-light md:font-normal">
                      {parse(singleAbout.Description)}
                    </p>
                  </div>
                );
              })
            )}
          </div>
        </div>
      </div>

      <BottomAppBar />
    </>
  );
};

export default About;
